import React, { useState, useEffect, useRef } from "react"
import infoIcon from "@/public/icons/tooltip.svg"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import SelectDropdown from "@/components/core/SelectDropdown/SelectDropdown"
import { addDatalayer } from "@/components/cart/cartAnalytics"
import { getStock } from "@/utils/cart"
const PDPTrimCalculator = props => {
  const tempVal = props.templateType === "trim"
  const soldByBoxVal = props.soldByBox * props.soldByUom
  const soldVal = !tempVal ? soldByBoxVal.toFixed(2) : props.soldByUom
  const [linerLF, setLinerLF] = useState(
    props.totalNeeded ? props.totalNeeded : ""
  )

  const [displayValSF, setDisplayValSF] = useState(
    props?.allAdditinalInfo?.totalSFUserNeeded
      ? props?.allAdditinalInfo?.totalSFUserNeeded
      : ""
  )
  const [displayVal, setDisplayVal] = useState(
    props?.allAdditinalInfo?.totalUserNeeded
      ? props?.allAdditinalInfo?.totalUserNeeded
      : ""
  )
  const [overage, setOverage] = useState(props.overage ? props.overage : 15)

  const [customOverage, setCustomOverage] = useState("")
  const [totalOverage, setTotalOverage] = useState(0)
  const [totalLF, setTotalLF] = useState(0)
  const [pises, setPises] = useState(0)
  const [price, setPrice] = useState(0)
  const [addToCartButtonDisable, setAddToCartButtonDisable] = useState(true)
  const overageList = [0, 5, 10, 15, 20, "Custom"]
  const [trimTooltip, setTrimTooltip] = useState({
    sqFeetTooltip: false,
    overageTooltip: false,
    totalCoverageTooltip: false,
  })
  const trimCalculationMainBlockElementRef = useRef(null)
  const ftNeededTooltipStaticText = tempVal
    ? props.staticTexts.linearFtNeeded
    : props.staticTexts.squareFtNeeded
  const [totalSoldValue, setTotalSoldValue] = useState(0)
  const [stockValue, setStockValue] = useState(
    props?.stockValue ? props?.stockValue : 0
  )
  const [isUserInput, setIsUserInput] = useState(false)
  useEffect(() => {
    const trimCalculatorTotalSqFt = Number(displayValSF)
      ? Number(displayValSF)?.toFixed(3)
      : totalLF.toFixed(3)
    setDisplayVal(
      ((trimCalculatorTotalSqFt * 100) / (Number(overage) + 100)).toFixed(2)
    )
  }, [])

  const onChangeHandler = value => {
    setIsUserInput(true)
    if (!value) {
      setTotalLF(0)
      setTotalOverage(0)
      setPises(0)
      setPrice(0)
      localStorage.setItem("itemFinalPrice", 0)
      setDisplayVal("")
      setDisplayValSF("")
      setLinerLF("")
      return false
    }
    if (value < 0) {
      document.getElementById("txt_prod_price").value = 0
      setDisplayVal("")
      setDisplayValSF("")
      setLinerLF(0)
      return false
    }
    const arr = value?.split(".")
    if (value?.length <= 5 || (arr?.length <= 2 && arr[1]?.length <= 2)) {
      setDisplayVal("")
      setDisplayValSF("")
      setLinerLF(value)
    }
  }
  const trimTooltipHandler = (
    sqFeetTooltip,
    overageTooltip,
    totalCoverageTooltip,
    msg
  ) => {
    setTrimTooltip({
      sqFeetTooltip: sqFeetTooltip,
      overageTooltip: overageTooltip,
      totalCoverageTooltip: totalCoverageTooltip,
    })
    addDatalayer({
      title: "info icon mouseover",
      section: "recalculate your space modal",
      tooltipVal: msg?.toLowerCase(),
      productInfo: props.productInfo,
    })
  }
  const onChangeCustomOverage = custVal => {
    if (custVal < 0) {
      document.getElementById("trim-calculator__overage-input-box").value = 0
      setCustomOverage(0)
      return false
    }
    const dot = custVal.split(".")
    if (dot.length === 2 || dot[0] === "") {
      setCustomOverage("")
    }
    if (dot.length !== 2 && dot[0] !== "" && custVal.length <= 2) {
      setCustomOverage(custVal)
    }
  }
  const onChangeOverage = (
    value = null,
    addDL = false,
    sqaureFeetSelection = false,
    customOverageSelection = false
  ) => {
    let res = 0
    setOverage(value)
    const tmpOverageVal =
      value?.toLowerCase?.() === "custom" ? customOverage : value
    res = (Number(linerLF) * Number(tmpOverageVal)) / 100
    const total = res + Number(linerLF)
    const pres =
      soldVal !== undefined && soldVal > 0 ? Math.ceil(total) * soldVal : 0
    const boxPeice =
      soldVal !== undefined && soldVal > 0
        ? (props.soldByUom * Math.ceil(total)) / props.soldByBox
        : 0
    setPises(!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres))
    const tempValPrice = !tempVal
      ? stockValue < Math.ceil(boxPeice)
        ? stockValue
        : Math.ceil(boxPeice)
      : stockValue < Math.ceil(pres)
      ? stockValue
      : Math.ceil(pres)
    const priceByBox =
      props?.discountPrice > 0 ? props.discountPrice : props.priceByBox
    const validPriceByBox = priceByBox !== undefined
    const isValid = validPriceByBox && priceByBox > 0
    const finalPrice = isValid ? tempValPrice * priceByBox : 0
    setPrice(finalPrice)
    localStorage.setItem("itemFinalPrice", finalPrice)
    const tOverage =
      soldVal !== undefined && soldVal > 0
        ? stockValue < Math.ceil(pres)
          ? stockValue / soldVal
          : Math.ceil(pres) / soldVal
        : 0
    const tileOverage =
      soldVal !== undefined && soldVal > 0
        ? (props?.soldByBox / props?.soldByUom) *
          (stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice))
        : 0
    setTotalOverage(!tempVal ? tileOverage : tOverage)
    setTotalLF(Math.ceil(total))
    addDL &&
      addDatalayer({
        title: "calculate footage",
        section: "recalculate your space modal",
        productInfo: props.productInfo,
        sqaureFeetSelection,
        calculated_Values: JSON.stringify({
          squareFeetNeeded: Number(linerLF),
          overage: customOverageSelection
            ? Number(customOverage)
            : value?.toLowerCase?.() === "custom"
            ? "custom"
            : Number(value),
          totalSquareFeet: Number(Math.ceil(total).toFixed(3)),
          totalCoverage: Number((!tempVal ? tileOverage : tOverage).toFixed(3)),
          totalBoxes: Math.ceil(tempValPrice),
          totalPrice: Number(finalPrice.toFixed(3)),
        }),
      })
  }
  const onBlurHandler = (
    value,
    addDL = false,
    sqaureFeetSelection = false,
    customOverageSelection = false
  ) => {
    const addToCartRef = document.querySelector(".add-to-cart__main-button")
    const stickyHeaderRef = document.querySelector(
      ".sticky-header__main-button"
    )
    if (addToCartRef) {
      if ((Number(linerLF) && Number(pises) > 0) || Number(value) > 0) {
        addToCartRef.classList.remove("disabled")
        setAddToCartButtonDisable(false)
        stickyHeaderRef?.classList?.remove("disabled")
      } else {
        addToCartRef.classList.add("disabled")
        setAddToCartButtonDisable(true)
        stickyHeaderRef?.classList?.add("disabled")
      }
    }
    if (linerLF) {
      onChangeOverage(
        overage,
        addDL,
        sqaureFeetSelection,
        customOverageSelection
      )
    }
  }
  const onCustomOverageBlur = () => {
    onBlurHandler(linerLF, true, false, true)
  }
  useEffect(() => {
    if (props.shwoInModal) {
      onBlurHandler(linerLF)
    }
  }, [])
  useEffect(() => {
    trimCalculationMainBlockElementRef.current.classList.toggle(
      "remove-while-print",
      addToCartButtonDisable
    )
  }, [addToCartButtonDisable])
  useEffect(() => {
    const tmpTiletotalSoldValue = props.soldByBox / props.soldByUom
    const tmpTrimtotalSoldValue = 1 / props.soldByUom
    setTotalSoldValue(!tempVal ? tmpTiletotalSoldValue : tmpTrimtotalSoldValue)
  }, [props.soldByBox, props.soldByUom])

  const updateCartHandler = () => {
    props.updateRecalculateCarts()
    addDatalayer({
      title: `${props.i18n.recalculateUpdateCart.toLowerCase()}`,
      section: `recalculate your space modal`,
      productInfo: props.productInfo,
      calculated_Values: JSON.stringify({
        squareFeetNeeded: Number(linerLF),
        overage: Number(overage) || Number(customOverage),
        totalSquareFeet: Number(totalLF.toFixed(3)),
        totalCoverage: Number(totalOverage.toFixed(3)),
        totalBoxes: Math.ceil(pises),
        totalPrice: Number(price.toFixed(3)),
      }),
    })
  }

  useEffect(() => {
    if (props?.sku) {
      getStock(props?.sku).then(({ stock = 0 }) => {
        if (stock) {
          setStockValue(stock)
        }
      })
    }
  }, [pises])

  return (
    <div
      id="trim-calculator_main-block"
      ref={trimCalculationMainBlockElementRef}
      className="trimWrapper trim-calculator_main-block"
      totaloverage={totalOverage.toFixed(3)}
      totalpeices={pises}
      soldbyuom={props.soldByUom ? props.soldByUom : ""}
      soldbybox={props.soldByBox ? props.soldByBox : ""}
      templatetype={props.templateType ? props.templateType : ""}
    >
      <div className="cart-landing-recalculate__tile-calculator__title">
        <span>{props.staticTexts.cartLandingCalculatorTitle}</span>
      </div>
      <div className="cart-landing-recalculate__tile-calculator__description">
        <span>
          {tempVal
            ? props.staticTexts.cartLandingCalculatorDescriptionLF
            : props.staticTexts.cartLandingCalculatorDescription}
        </span>
      </div>
      <div className="inputWrapper">
        <div className="inputBox">
          <span className="inputBoxLabel">
            {tempVal
              ? props.staticTexts.linearFtNeeded
              : props.staticTexts.squareFtNeeded}
            <img
              src={infoIcon?.src}
              alt=""
              role="tooltip"
              tabIndex={0}
              onMouseOver={() =>
                trimTooltipHandler(
                  true,
                  false,
                  false,
                  props?.customLabel?.ftneededToolTip
                    ? props.customLabel.ftneededToolTip
                    : ftNeededTooltipStaticText
                )
              }
              onMouseLeave={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              className="trimCalculatorTooltipIcon"
            />
            <div
              className={`trim-calculator__list-tooltip${
                trimTooltip.sqFeetTooltip ? "--show" : "--hide"
              }`}
            >
              <div className="trim-calculator__list-tooltip-wrapper">
                <ToolTip
                  message={
                    props?.customLabel?.ftneededToolTip
                      ? props.customLabel.ftneededToolTip
                      : ftNeededTooltipStaticText
                  }
                />
              </div>
            </div>
          </span>
          <input
            type="number"
            className="trim-calculator__square-ft-value"
            id="txt_prod_price"
            value={displayVal ? displayVal : linerLF}
            onChange={e => onChangeHandler(e.target.value)}
            onBlur={e => onBlurHandler(e.target.value, true, true)}
          />
          <div className="labelLF">
            {tempVal ? props.staticTexts.lf : props.staticTexts.sf}
          </div>
        </div>
        <div className="inputBox">
          <span className="inputBoxLabel">
            {props?.customLabel?.overagename
              ? props.customLabel.overagename
              : props.staticTexts.overage}
            <img
              src={infoIcon?.src}
              alt=""
              role="tooltip"
              tabIndex={0}
              onMouseOver={() =>
                trimTooltipHandler(
                  false,
                  true,
                  false,
                  props?.customLabel?.overageNameToolTip
                    ? props.customLabel.overageNameToolTip
                    : props.staticTexts.overage
                )
              }
              onMouseLeave={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              className="trimCalculatorTooltipIcon"
            />
            <div
              className={`trim-calculator__list-tooltip${
                trimTooltip.overageTooltip ? "--show" : "--hide"
              }`}
            >
              <div className="trim-calculator__list-tooltip-wrapper">
                <ToolTip
                  message={
                    props?.customLabel?.overageNameToolTip
                      ? props.customLabel.overageNameToolTip
                      : props.staticTexts.overage
                  }
                />
              </div>
            </div>
          </span>
          <SelectDropdown
            data={overageList}
            value={overage}
            onChange={selectedValue =>
              onChangeOverage(selectedValue, true, false)
            }
            id="trim-calculator__overage-value"
          />
          {(overage === "custom" || overage === "Custom") && (
            <input
              type="number"
              value={customOverage}
              onChange={e => onChangeCustomOverage(e.target.value)}
              onBlur={onCustomOverageBlur}
              id="trim-calculator__overage-input-box"
            />
          )}
        </div>
      </div>
      <div className="totalLFWrapper">
        <div className="labelText">
          {tempVal ? props.staticTexts.totalLF : props.staticTexts.totalSF}
        </div>
        <div
          className="valText"
          id="trim-calculator__totalSquareFeet"
          value={
            Number(displayValSF)
              ? Number(displayValSF)?.toFixed(3)
              : totalLF.toFixed(3)
          }
        >
          {Number(displayValSF)
            ? Number(displayValSF)?.toFixed(3)
            : totalLF.toFixed(3)}{" "}
          <span className="text">
            {tempVal ? props.staticTexts.lf : props.staticTexts.sf}
          </span>
        </div>
      </div>
      <div className="totalBox">
        <div className="leftBox">
          <span>{props.staticTexts.totalCoverage}</span>
          <label>
            {props.staticTexts.whatYouWillReceive}
            <img
              src={infoIcon?.src}
              alt=""
              role="tooltip"
              tabIndex={0}
              onMouseOver={() =>
                trimTooltipHandler(
                  false,
                  false,
                  true,
                  props?.customLabel?.totalCoverageToolTip
                    ? props.customLabel.totalCoverageToolTip
                    : props.staticTexts.totalCoverage
                )
              }
              onMouseLeave={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              className="trimCalculatorTooltipIcon"
            />
            <div
              className={`trim-calculator__list-tooltip${
                trimTooltip.totalCoverageTooltip ? "--show" : "--hide"
              }`}
            >
              <div className="trim-calculator__list-tooltip-wrapper">
                <ToolTip
                  message={
                    props?.customLabel?.totalCoverageToolTip
                      ? props.customLabel.totalCoverageToolTip
                      : props.staticTexts.totalCoverage
                  }
                />
              </div>
            </div>
          </label>
        </div>
        <div className="rightBox">
          <div
            className="valText"
            id="trim-calculator__totalCoverage"
            value={isUserInput ? totalOverage.toFixed(2) : props?.totalArea}
          >
            {isUserInput ? totalOverage.toFixed(2) : props?.totalArea}{" "}
            <span className="text">{`${tempVal ? "LF" : "SF"}`}</span>
          </div>
        </div>
      </div>
      <div className="totalBox">
        <div className="leftBox">
          <span>
            {tempVal
              ? props.staticTexts.totalPieces
              : props.staticTexts.totalBoxes}
          </span>
          <label>{`${tempVal ? "Trim" : "Tile"} sold by the ${
            tempVal ? "piece" : "box"
          } (${totalSoldValue.toFixed(2)} ${
            tempVal ? "LF / Each" : "SF / Box"
          })`}</label>
        </div>
        <div className="rightBox">
          <div
            className="valText"
            id="trim-calculator__totalBoxes"
            value={
              isUserInput
                ? stockValue < pises
                  ? stockValue
                  : pises
                : props?.totalBoxes
            }
          >
            {isUserInput
              ? stockValue < pises
                ? stockValue
                : pises
              : props?.totalBoxes}{" "}
            <span className="text">{`${tempVal ? "PIECES" : "BOXES"}`}</span>
          </div>
        </div>
      </div>
      <div className="totalBox">
        <div className="leftBox">
          <span>{props.staticTexts.totalPrice}</span>
          <label>{`${tempVal ? "Price / Ea" : "Price / Box"} ${
            props.discountPrice > 0 ? props.discountPrice : props.priceByBox
          }`}</label>
        </div>
        <div className="rightBox">
          <div
            className="finalTotal"
            id="trim-calculator__finalTotal"
            price={isUserInput ? price.toFixed(2) : props?.totalPrice}
          >
            {`$${isUserInput ? price.toFixed(2) : props?.totalPrice}`}
          </div>
        </div>
      </div>
      <div className="cart-landing-recalculate__add-to-cart">
        <a
          href="#"
          className="cart-landing-recalculate__add-to-cart-btn"
          onClick={updateCartHandler}
        >
          {props.i18n.recalculateUpdateCart}
        </a>
      </div>
    </div>
  )
}
export default PDPTrimCalculator
